import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Los Angeles">
                <h1>Mobile App Development Company in Los Angeles</h1>
              </div>
              <p className="main_para">
                TekRevol has a team of professional app developers in Los
                Angeles along with UI/UX designers, Project Managers, and Q/A
                specialists to bring your app ideas to life. With our core focus
                being on the user experience and your business’s scalability,
                TekRevol’s team has built numerous award-winning consumer-side
                apps and enterprise-grade solutions that have gone on to help
                them disrupt domains and ensure optimal outcomes in the
                long-run.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                {" "}
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
